<template>
    <div class="my-orders">
        <h3 class="mb-3">Tax Admin</h3>
        <div class='form-group'>
            <select class='form-control' v-model="state">
                <option v-for="(name, key) in stateList" v-bind:value="key">{{name}}</option>
            </select>
        </div>
        <div class='form-group'>
            <button v-bind:disabled="busy" class='btn btn-primary' @click="importTaxData">
                <span v-if="!busy">
                    Import Tax Data
                </span>
                <font-awesome-icon v-if="busy" :icon="['fad', 'circle-notch']" spin />
            </button>
        </div>
    </div>
</template>

<style lang="scss" scoped>
</style>

<script>

export default {
    data: () => ({
        busy: false,
        state: 'CA',
        stateList: {
            "AL": "Alabama",
            "AK": "Alaska",
            "AS": "American Samoa",
            "AZ": "Arizona",
            "AR": "Arkansas",
            "CA": "California",
            "CO": "Colorado",
            "CT": "Connecticut",
            "DE": "Delaware",
            "DC": "District Of Columbia",
            "FM": "Federated States Of Micronesia",
            "FL": "Florida",
            "GA": "Georgia",
            "GU": "Guam",
            "HI": "Hawaii",
            "ID": "Idaho",
            "IL": "Illinois",
            "IN": "Indiana",
            "IA": "Iowa",
            "KS": "Kansas",
            "KY": "Kentucky",
            "LA": "Louisiana",
            "ME": "Maine",
            "MH": "Marshall Islands",
            "MD": "Maryland",
            "MA": "Massachusetts",
            "MI": "Michigan",
            "MN": "Minnesota",
            "MS": "Mississippi",
            "MO": "Missouri",
            "MT": "Montana",
            "NE": "Nebraska",
            "NV": "Nevada",
            "NH": "New Hampshire",
            "NJ": "New Jersey",
            "NM": "New Mexico",
            "NY": "New York",
            "NC": "North Carolina",
            "ND": "North Dakota",
            "MP": "Northern Mariana Islands",
            "OH": "Ohio",
            "OK": "Oklahoma",
            "OR": "Oregon",
            "PW": "Palau",
            "PA": "Pennsylvania",
            "PR": "Puerto Rico",
            "RI": "Rhode Island",
            "SC": "South Carolina",
            "SD": "South Dakota",
            "TN": "Tennessee",
            "TX": "Texas",
            "UT": "Utah",
            "VT": "Vermont",
            "VI": "Virgin Islands",
            "VA": "Virginia",
            "WA": "Washington",
            "WV": "West Virginia",
            "WI": "Wisconsin",
            "WY": "Wyoming"
        }
    }),
    methods: {
        importTaxData () {
            this.busy = true
            this.$http({
                'url': 'dashboard/tax/import',
                'method': 'POST',
                params: {
                    state: this.state
                }
            }).then((response) => {
                this.busy = false
                this.$swal({
                    toast: true,
                    html: 'Changes saved',
                    type: 'success',
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                })
            }).catch((error) => {
                this.busy = false
                this.$swal({
                    toast: true,
                    html: 'Whoops, something went wrong.',
                    type: 'error',
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                })               
            })
        },
    },
    mounted () {
    },
}
</script>
